import { render, staticRenderFns } from "./OnboardingPortalStats.vue?vue&type=template&id=be8f4cd2&"
import script from "./OnboardingPortalStats.vue?vue&type=script&lang=js&"
export * from "./OnboardingPortalStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports